export default "__VITE_ASSET__GPbwxB_r__"